__turbopack_context__.v({
  "container": "styles-module-scss-module__phNmSq__container",
  "increasedClickArea": "styles-module-scss-module__phNmSq__increasedClickArea",
  "leftAlign": "styles-module-scss-module__phNmSq__leftAlign",
  "playPauseButtonContainer": "styles-module-scss-module__phNmSq__playPauseButtonContainer",
  "video": "styles-module-scss-module__phNmSq__video",
});
